<template>
  <FiltersItemContent>
    <template #content>
      <BaseToggle
        :checked="hideAiportChange"
        :text="$l('showresult.filter.hideChangeAirport')"
        @update:checked="hideAiportChangeClick"
      />
      <BaseToggle
        :checked="hideLongChanging"
        :text="$l('showresult.filter.hideLongChanging')"
        @update:checked="hideLongChangingClick"
      />
    </template>
  </FiltersItemContent>
</template>

<script setup>
import { useFiltersStore } from './store/filtersStore';
import { useResultQueryStore } from './store/resultQueryStore';

const filtersStore = useFiltersStore();
const resultQueryStore = useResultQueryStore();


const hideLongChanging = computed(() => {
	const maxWaitTime = resultQueryStore?.state?.response?.uniqueWaittime?.length > 5 ? resultQueryStore?.state?.response?.uniqueWaittime[Math.floor(resultQueryStore.state.response.uniqueWaittime.length / 5)] : 10800;
	if (filtersStore.state?.airportWaitTime?.[1] <= maxWaitTime) {
		return true;
	}
	return false;
});

const hideAiportChange = computed(() => !!filtersStore.state.changesAirport);

function hideLongChangingClick (checked) {
	// Null is set here so that the filter is cleared from the url
	const value = checked ? true : null;
	const minWaitTime = 0;

	// max waiting time is the first 20% of waiting times available in the result, if there are less than 6 unique waiting times default to 3h.
	const maxWaitTime = resultQueryStore.state.response.uniqueWaittime.length > 5 ? resultQueryStore.state.response.uniqueWaittime[Math.floor(resultQueryStore.state.response.uniqueWaittime.length / 5)] : 10800;
	filtersStore.set({ key: 'airportWaitTime', value: value ? [minWaitTime, maxWaitTime] : null });
}

function hideAiportChangeClick (checked) {
	const value = checked ? true : null;
	filtersStore.set({ key: 'changesAirport', value });
}

</script>

<style>

</style>
